module.exports = __webpack_public_path__ + "img/SES_205428804.8ed1b8ed.jpg";